<template>
    <v-row :class="mdAndDown ? 'ma-0 mt-3' : 'ma-0'" justify="center">
        <v-col cols='12' class="pa-0" align-self="center">
            <span class="subtitleDashboard"> {{ t('labels.ociTitle') }} <span class="subtitleDashboard" style="font-size: 24px !important;" >{{ t('labels.oci') }}</span> </span>

            <IEOCardComponent :width="330" />

            <div class="mt-8 mb-2 text-left">
                {{ t('labels.msn') }}
            </div>

            <TimeLineAlerts 
                class="text-left"
                v-if="showAlertTimeLine"
                :array-items="allAlertItems"
                :width="smAndDown ? 400 : 315"
                :height="heightTimeLine"
                :isRecurrent="true"
            />
            <span v-else class="text-left"> {{ t('noAlertsAlarmRecurren') }} </span>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import type { PropType } from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import IEOCardComponent from '@/components/SmartLink/dashboard/IEOCardComponent.vue';
import TimeLineAlerts from '@/components/SmartLink/dashboard/TimeLineAlerts.vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { mdAndDown, smAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** INTERFACES **********
 *******************************/
import { ALARMTYPE } from '@/interfaces/SmartLink/KPI';

// 1. Recibir las alarmas recurrentes desde DashBoardView.vue
const props = defineProps({
    recurrentAlarms: { 
        type: Array as PropType<ALARMTYPE[]>, 
        default: () => [] 
    }
});

const heightTimeLine = ref(492);

// 2. Computed seguros para reaccionar a la prop sin errores
const allAlertItems = computed(() => props.recurrentAlarms || []);
const showAlertTimeLine = computed(() => allAlertItems.value.length > 0);
</script>